/** Product name used across the page and in pixel events. */
export const PRODUCT_NAME = 'Arsenał Nauczyciela Jazzu'

/** Main product mockup (6 volumes + bonuses on devices). */
export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/vL3a7ZezmJRFuApQTcxmoi/Imagen_de_ChatGPT_30_sept_2026,_12_18_55_p.m..png'
